module.exports = __webpack_public_path__ + "static/media/goods4.74204461.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_136/imgs/goods4.png
// module id = 1230
// module chunks = 0